import { Form, Field, Divider, Icon } from "vant";
import { getToken } from "@/utils/auth.js";
import { getWXCodeOrToRegister } from "@/utils/login.js";
import { queryOtherRepay } from "@/api/repay-info.js";
import { hkztFormatter, hkztColorFormatter } from "@/utils/formatter.js";
import { wxPayAll } from "@/api/pay.js";
// import { showToRepay } from "./repay.js";
import { wxNativePay } from "@/utils/wxpay.js";
export default {
  name: "OtherRepay",
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Divider.name]: Divider,
    [Icon.name]: Icon
  },
  data() {
    return {
      openId: "",
      checkIDCard: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
      checkPhone: /^1[3456789]\d{9}$/,
      plan: {},
      list: [],
      total: 0
    };
  },
  created() {
    console.log("OtherRepay.vue created");
    getWXCodeOrToRegister(this.$route, this.setOpenId);
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    setOpenId(openId) {
      this.openId = openId;
    },
    queryOtherRepayplan(plan) {
      console.log(plan);
      this.$toast.loading("加载中...");
      queryOtherRepay(plan.sjhm, plan.khmc, plan.sfzhm)
        .then(response => {
          this.$toast.clear();
          console.log(response);
          if (response.data.code === 200) {
            this.list = response.data.results.data;
            this.total = response.data.results.total;
            if (this.total === 0) {
              this.$toast.fail("无还款信息");
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    hkztFormatter(hkzt) {
      return hkztFormatter(hkzt);
    },
    hkztColorFormatter(hkzt) {
      return hkztColorFormatter(hkzt);
    },
    // showToRepay(hkzt, hkrq) {
    //   return showToRepay(hkzt, hkrq);
    // },
    toRepay(item) {
      console.log("从后台获取支付的链接");
      const payId = item.id;
      this.$toast.loading("加载中...");
      wxPayAll(payId, getToken(), { isOther: "1" })
        .then(response => {
          this.$toast.clear();
          console.log(response);
          if (response.data.code === 200) {
            window.location.href = response.data.results;
          } else if (response.data.code === 201) {
            this.$toast.fail(response.data.message);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    wxpay(data, route, query, func, param) {
      wxNativePay(data, route, query, func, param);
    }
  }
};
